import styled from 'styled-components';

const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: #ffffff;
	opacity: 0.1;
`;

export { Divider };
